import React from 'react';
import {useTranslation} from 'react-i18next';
import {Icon} from '@iconify/react';
import TooltipWrapper from './common/TooltipWrapper';
import {ProtectionType} from '../../incase-domain/presentationProtection';
import AaiEduLogo from '../../../assets/aailogoh.png';
import ZoomLogo from '../../../assets/zoom-logo-thumbnail.png';
import NobulaLogo from '../../../assets/icons/NobulaLogo.svg';
import EmedikusLogo from '../../../assets/icons/e-medikus-compact-logo-textless.svg';
import {randomString} from '../util/util';

interface ProtectionTypeIconsProps {
    protectionTypes: ProtectionType[];
}

function ProtectionTypeIcons({protectionTypes}: ProtectionTypeIconsProps): JSX.Element {
    const {t} = useTranslation();

    const getProtectionTypeIcon = (protectionType: ProtectionType): JSX.Element => {
        switch (protectionType) {
            case ProtectionType.GUEST:
                return <Icon icon="solar:users-group-two-rounded-linear" />;
            case ProtectionType.PASSWORD:
                return <Icon icon="solar:password-linear" />;
            case ProtectionType.REGISTERED_USERS:
                return <img src={NobulaLogo} alt="nobulaLogo" />;
            case ProtectionType.SELECTED_USERS:
                return <img src={NobulaLogo} alt="nobulaLogo" />;
            case ProtectionType.AAI_EDU:
                return <img src={AaiEduLogo} alt="aaiLogo" />;
            case ProtectionType.ZOOM:
                return <img src={ZoomLogo} alt="zoomLogo" />;
            case ProtectionType.EMEDIKUS:
                return <img src={EmedikusLogo} alt="emedikusLogo" />;
            default:
                return <Icon icon="solar:lock-keyhole-minimalistic-linear" />;
        }
    };

    let content = t('presEditPage.settings.presProtection.protectionTypes.private');
    if (protectionTypes.length > 0) {
        content = protectionTypes.map((type) => t(`presEditPage.settings.presProtection.protectionTypes.${type}`)).join(', ');
    }

    return (
        <div className="c-protectionTypeIcons">
            <TooltipWrapper className="e-table__icon" id={randomString()} content={content} place="left">
                {protectionTypes.length === 0 ? (
                    <Icon icon="solar:lock-keyhole-minimalistic-linear" />
                ) : (
                    <div className="c-protectionTypeIcons__icon">
                        {getProtectionTypeIcon(protectionTypes[0])}
                        {protectionTypes.length > 1 && (
                            <span>{t('presEditPage.settings.presProtection.more', {count: protectionTypes.length - 1})}</span>
                        )}
                    </div>
                )}
            </TooltipWrapper>
        </div>
    );
}

export default ProtectionTypeIcons;
